export const G2_REVIEW_PROMPT_CAP = 80 as const;

export const REVIEW_PROMPT_G2_PLAN_IDS = [
  861441, 861446, 861443, 861448, 861442, 861447,
] as const;

export const REVIEW_PROMPT_CAPTERRA_PLAN_IDS = [
  861439, 861444, 861440, 861445,
] as const;

export const REVIEW_PROMPT_G2_TYPEFORM_ID = 'oSWJmiq5';

export const REVIEW_PROMPT_CAPTERRA_TYPEFORM_ID = 'zYcrBx3i';

export const REVIEW_PROMPT_G2_MODAL_TITLE =
  "How's your experience with the SMS Reminder app so far?";

export const REVIEW_PROMPT_CAPTERRA_MODAL_TITLE =
  "How's your experience with SMS Reminder app so far?";

export type ReviewPromptPlatform = 'g2' | 'capterra';

const G2_PLAN_ID_SET = new Set<number>(REVIEW_PROMPT_G2_PLAN_IDS);
const CAPTERRA_PLAN_ID_SET = new Set<number>(REVIEW_PROMPT_CAPTERRA_PLAN_IDS);

export function resolveReviewPromptPlatform(
  planId: number | null | undefined,
): ReviewPromptPlatform | null {
  if (planId == null) {
    return null;
  }

  if (G2_PLAN_ID_SET.has(planId)) {
    return 'g2';
  }

  if (CAPTERRA_PLAN_ID_SET.has(planId)) {
    return 'capterra';
  }

  return null;
}
